import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { account } from '../api/client';
import PasswordField from '../components/PasswordField';

/** Self-service password change, opened from the user menu. */
export default function ChangePassword({ open, onClose, onDone }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  function reset() {
    setCurrent(''); setNext(''); setConfirm(''); setError(null);
  }

  async function submit(e) {
    e.preventDefault();
    setError(null);
    if (next.length < 8) return setError('New password must be at least 8 characters.');
    if (next !== confirm) return setError('The two new passwords do not match.');
    setBusy(true);
    try {
      await account.changePassword(current, next);
      reset();
      onDone('Password changed. Use the new one next time you sign in.');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onClose={() => { reset(); onClose(); }} fullWidth maxWidth="xs"
            slotProps={{ paper: { component: 'form', onSubmit: submit } }}>
      <DialogTitle sx={{ fontWeight: 650 }}>Change password</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <PasswordField label="Current password" value={current} required autoFocus
                         autoComplete="current-password" onChange={(e) => setCurrent(e.target.value)} />
          <PasswordField label="New password" value={next} required helperText="At least 8 characters"
                         autoComplete="new-password" onChange={(e) => setNext(e.target.value)} />
          <PasswordField label="Confirm new password" value={confirm} required
                         autoComplete="new-password" onChange={(e) => setConfirm(e.target.value)} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button color="inherit" onClick={() => { reset(); onClose(); }}>Cancel</Button>
        <Button type="submit" variant="contained" disabled={busy}>
          {busy ? 'Saving…' : 'Change password'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
